<template>
    <div class="form-group" :class="computedClasses">
        <div
            class="form-check city-form-check mb-0 pl-0 user-select-none"
            :class="[{ 'form-check-inline': isInline }, inputClasses]"
        >
            <input
                :false-value="falseValue"
                :true-value="trueValue"
                :readonly="readonly"
                :disabled="disabled"
                :required="required"
                class="form-control"
                type="checkbox"
                :name="name"
                :id="id"
                :title="title"
                :checked="isChecked"
                @change="handleCheckboxChange"


            />

            <label
                class="form-check-label h-auto"
                :class="[labelClass]"
                :for="id"
            >
                <div class="d-flex align-items-start align-items-center flex-nowrap flex-row"><slot> &nbsp;</slot></div>
            </label>
            <small
                v-if="error"
                class="invalid-feedback"
                >{{ error }}</small
            >
            <HelpSpan
                :helpText="helpText"
                :truncateText="helpTruncate"
            />
        </div>
    </div>
</template>

<script>
/*
Validação 'required' = TRUE apenas funciona com uma das seguintes configurações:

 Estático:
   v-validate="'required:true'"

 Dinâmico:
   :false-value="null"
   v-validate="{ required: isRequired }"

 Garante que valores como false ou null não passem na validação.
*/

export default {
    name: "material-checkbox",
    components: {
        HelpSpan: () => import(/* webpackChunkName: "help-span" */ "@/components/form/HelpSpan.vue")
    },

    data() {
        return {
            valueCopy: null,
            valid: true
        };
    },
    computed: {
        isChecked() {
            if (Array.isArray(this.valueCopy)) {
                return this.valueCopy.includes(this.checkboxValue);
            }
            return String(this.valueCopy) === String(this.trueValue);
        },
        isInline() {
            return this.inLine && !this.helpText;
        },
        computedClasses () {
            return {}
        },
    },
    beforeMount() {
        // Here we are following the Vue2 convention on custom v-model:
        // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
        this.copyValue(this.value);
    },
    mounted() {},
    methods: {
        copyValue(value) {
            this.valueCopy = value;
        },

        handleCheckboxChange(event) {
            if (Array.isArray(this.valueCopy)) {
                const newValue = [...this.valueCopy];
                const index = newValue.indexOf(this.checkboxValue);
                if (event.target.checked && index === -1) {
                    newValue.push(this.checkboxValue);
                } else if (!event.target.checked && index !== -1) {
                    newValue.splice(index, 1);
                }
                this.$emit("input", newValue, event);
            } else {
                const newValue = event.target.checked ? this.trueValue : this.falseValue;
                this.$emit("input", newValue, event);
            }
        }
    },
    watch: {
        value(newValue) {
            this.copyValue(newValue);
        }
    },
    props: {
        id: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        },
        value: {
            default: null
        },
        checkboxValue: {
            default: null
        },
        falseValue: {
            type: [String, Number, Boolean],
            default: false
        },
        trueValue: {
            type: [String, Number, Boolean],
            default: true
        },

        inLine: {
            type: Boolean,
            default: true
        },

        title: {
            type: String,
            default: null
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },

        required: {
            type: Boolean,
            default: false
        },

        inputClasses: {
            type: [Array, Object, String],
            default: null
        },

        labelClass: {
            type: Object,
            default: () => {
                return {};
            }
        },
        error: {
            type: String,
            default: null
        },
        helpText: {
            type: String,
            default: null
        },
        helpTruncate: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style scoped lang="scss">
@import "@styles/_theme.scss";
.form-check:not(.form-check-inline) label {
    transform: none;
    -webkit-transform: none;
    -moz-transform: none;
    -ms-transform: none;
    -o-transform: none;
}
.city-form-group label {
    //margin-bottom: 1.5rem !important;
}
.center.form-check-inline {
    display: flex;
    justify-content: center;
}
label {
    color: $grey-700;
}
input {
    caret-color: transparent;
}
</style>
